<template>
    <form>
        <ErrorSummary :response-status="responseStatus" />

        <div class="mt-10 divide-y divide-gray-200">
            <div class="space-y-1">
                <h3 class="text-xl font-bold leading-6 text-gray-900">Agent</h3>
                <p class="max-w-2xl text-sm text-clay-800"></p>
            </div>
            <div class="mt-6">
                <div class="divide-y divide-gray-200">
                    <div class="grid grid-cols-1 gap-6 mt-6 lg:grid-cols-3">
                        <div class="">
                            <label class="block text-sm font-medium text-gray-700" for="representedBy">Agent
                                Name</label>
                            <input id="representedBy" v-model="profile.representedBy"
                                class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="representedBy" type="text">
                        </div>

                        <div class="">
                            <label class="block text-sm font-medium text-gray-700" for="representationLocation">Agent
                                Location</label>
                            <input id="representationLocation" v-model="profile.representationLocation"
                                class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="representationLocation" type="text">
                        </div>

                        <div class="">
                            <label class="block text-sm font-medium text-gray-700" for="representationWebsite">Agent
                                Website <sup class="text-electric-700">PRO</sup></label>
                            <input id="representationWebsite" v-model="profile.representationWebsite"
                                class="block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="representationWebsite" type="text">
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="mt-10 divide-y divide-gray-200">
            <div class="space-y-1">
                <h3 class="text-xl font-bold leading-6 text-gray-900">Union Affiliations (Check all that apply. If
                    non-union, leave blank.)</h3>
                <p class="max-w-2xl text-sm text-clay-800"></p>
            </div>
            <div class="mt-6">
                <div class="">
                        <fieldset class="space-y-5">
                            <legend class="sr-only">Union Affiliations select</legend>
                            <div class="grid grid-cols-1 space-y-3 lg:grid-cols-3 lg:space-y-1">
                                <div v-for="option in profile.unionAffiliationsOptions"
                                    class="relative flex items-start">
                                    <div class="flex items-center h-5">
                                        <input :id="option" v-model="profile.unionAffiliations" :name="option"
                                            :value="option" aria-describedby=""
                                            class="w-4 h-4 border-clay-500 rounded text-powder-600 focus:ring-powder-500"
                                            type="checkbox">
                                    </div>
                                    <div class="ml-3 text-sm">
                                        <label :for="option" class="font-medium text-gray-700">{{ option }}</label>
                                        <span class="text-clay-800"></span>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                </div>
            </div>
        </div>
        <div class="py-3 mt-10 text-center">
            <SaButton @click.prevent="updateProfileRepresentation" :loading="isSubmitting" variant="primary"/>
        </div>

    </form>
    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
        title="Successfully saved!" />

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineComponent, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetProfileRepresentation, GetProfileRepresentationResponse,
    UpdateProfileRepresentation,
} from "@/dtos";
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SaButton from "@/main/components/SaButton.vue";

const responseStatus = ref(null);
const profile: Ref<GetProfileRepresentationResponse> = ref(new GetProfileRepresentationResponse());

onMounted(async () => {
    await client.get<GetProfileRepresentationResponse>(new GetProfileRepresentation())
        .then(response => {
            profile.value = response;
        });
});

const isSubmitting = ref(false);
const updateSuccessful= ref(false);
const updateProfileRepresentation = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    let request = profile.value;
    await client.post<ResponseStatus>(new UpdateProfileRepresentation(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
}

</script>
<style>

</style>